import React from 'react';
import Experiment from 'components/abTest/Experiment';
import { getRuntimeEnvVariables } from 'helpers/Utils';
import { LoginButtonsOrder } from '@hyphengroup/cag-components';
import { func } from 'prop-types';

function SignupBtnsExperiment ({ children }) {
  return (
    <Experiment
      experimentId={getRuntimeEnvVariables('RUNTIME_SIGNUP_BTNS_EXPERIMENT_ID')}
      controlVariantId={getRuntimeEnvVariables('RUNTIME_SIGNUP_BTNS_EXPERIMENT_CONTROL')}
      variantIds={(getRuntimeEnvVariables('RUNTIME_SIGNUP_BTNS_EXPERIMENT_VARIANTS') || '').split(',')}
    >
      {(variantId) => {
        let btnsOrder;
        switch (variantId) {
          case getRuntimeEnvVariables('RUNTIME_SIGNUP_BTNS_EXPERIMENT_VARIANT_1'):
            btnsOrder = LoginButtonsOrder.EGF;
            break;
          case getRuntimeEnvVariables('RUNTIME_SIGNUP_BTNS_EXPERIMENT_VARIANT_2'):
            btnsOrder = LoginButtonsOrder.GEF;
            break;
          default: btnsOrder = LoginButtonsOrder.FGE;
            break;
        }
        return children({ btnsOrder });
      }}
    </Experiment>
  );
}

SignupBtnsExperiment.propTypes = {
  children: func,
};

export default SignupBtnsExperiment;
